import { Grid2 as Grid, Tooltip, Grid2Props as GridProps } from "@mui/material";
import { Typography } from "@mui/material";

import React from "react";

export type TitleValueDisplayProps = {
	title: string;
	size?: "large" | "medium" | "small";
	strongValue?: boolean;
	strongTitle?: boolean;
	noWrap?: boolean;
	type?: TitleValueType;
	justifyValue?: GridProps["justifyContent"];
	titleGridXs?: number | "auto" | "grow";
	valueGridXs?: number | "auto" | "grow";
} & ({ value: JSX.Element | string | number; showCopyIcon?: false } | { value: string; showCopyIcon: true });

export enum TitleValueType {
	"Horizontal",
	"Vertical",
}

export const TitleValueDisplay: React.FC<TitleValueDisplayProps> = ({
	title,
	value,
	size,
	strongValue = true,
	strongTitle = false,
	type = TitleValueType.Vertical,
	justifyValue = "flex-start",
	titleGridXs = 8,
	valueGridXs = 4,
}) => {
	const renderTitle =
		(typeof title === "string" || typeof title == "number") && strongTitle ? <strong>{title}</strong> : title;
	const renderValue =
		(typeof value === "string" || typeof value == "number") && strongValue ? <strong>{value}</strong> : value;

	if (type === TitleValueType.Vertical) {
		return (
			<Grid container direction="column">
				<Grid container direction="row">
					<Typography variant={"body1"}>{renderTitle}</Typography>
				</Grid>
				<Grid container direction="row" spacing={3}>
					<Grid>
						<Typography
							variant={size === "large" ? "h4" : size === "medium" ? "h5" : size === "small" ? "h6" : "body1"}
						>
							{renderValue}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		);
	} else {
		return (
			<Grid container direction="row">
				<Grid size={titleGridXs}>
					{renderTitle}
				</Grid>
				<Grid container size={valueGridXs} justifyContent={justifyValue}>
					<Tooltip title={value.toString()} placement="top">
						<div>{renderValue}</div>
					</Tooltip>
				</Grid>
			</Grid>
		);
	}
};
